import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthOpenScheduling,
	GetHealthOpenSchedulingParams,
	GetHealthOpenSchedulingModel,
} from 'domain/usecases';

export class RemoteGetHealthOpenScheduling implements GetHealthOpenScheduling {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthOpenSchedulingModel>,
	) {}

	async get(params: GetHealthOpenSchedulingParams): Promise<GetHealthOpenSchedulingModel> {
		const {signal, ...requestParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: requestParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
